import Vue from 'vue'
import { mutateAll } from '@/store/utils'
import { createInitialState } from './index'

export const setCompanyDetails = (state, payload) => {
  Vue.set(state, 'companyDetails', payload)
}

export const setSendingTransportState = (state, payload) => {
  Vue.set(state, 'isSending', payload)
}

export const reset = state => {
  mutateAll(state, createInitialState())
}
